var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "loader",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      attrs: {
        "is-loading": _vm.isLoadingCurrent,
        "is-empty": !_vm.properties_360,
        "i18n-path": "properties_360"
      }
    },
    [
      _c(
        "v-tabs",
        {
          attrs: {
            "active-class": "primary--text",
            height: _vm.FRI_TABS_HEIGHT,
            "background-color": _vm.$vuetify.theme.themes[_vm.theme].background,
            grow: "",
            "show-arrows": ""
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c(
            "v-tab",
            [
              _c("button-icon", {
                attrs: {
                  icon: "mdi-file-document-outline",
                  label: "Informations générales",
                  active: _vm.tab === 0
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            [
              _c("button-icon", {
                attrs: {
                  icon: "mdi-briefcase-outline",
                  label: "Opération de maintenance",
                  active: _vm.tab === 1
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.properties_360.p1_monitoring
            ? _c(
                "v-tab",
                [
                  _c("button-icon", {
                    attrs: {
                      icon: "mdi-poll",
                      label: "Relèves",
                      active: _vm.tab === 2
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-tab",
            [
              _c("button-icon", {
                attrs: {
                  icon: "mdi-lightbulb-on-outline",
                  label: "Efficacité énergétique",
                  active: _vm.properties_360.p1_monitoring
                    ? _vm.tab === 3
                    : _vm.tab === 2
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            [
              _c("button-icon", {
                attrs: {
                  icon: "mdi-wrench",
                  label: "Matériel",
                  active: _vm.properties_360.p1_monitoring
                    ? _vm.tab === 4
                    : _vm.tab === 3
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticClass: "overflow-y-auto overflow-x-hidden",
          style: {
            height: _vm.height + "px",
            background: _vm.$vuetify.theme.themes[_vm.theme].background
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tab-item", [_c("general-informations-tab")], 1),
          _vm._v(" "),
          _c("v-tab-item", [_c("maintenance-operations-tab")], 1),
          _vm._v(" "),
          _vm.properties_360.p1_monitoring
            ? _c(
                "v-tab-item",
                [
                  _c("summary-property-readings", {
                    attrs: { "property-id": _vm.properties_360.id }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-tab-item", [_c("energy-performance-tab")], 1),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [_c("equipment-tab", { attrs: { height: _vm.height } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }